// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"io9Ec","nic":"V4478","timesview":"_ubXH","author_name":"wbnhL","isBlurb":"GpeBV","blog_text":"dZVbJ"};